import { render, staticRenderFns } from "./CzIcon.vue?vue&type=template&id=02381da3&scoped=true&"
import script from "./CzIcon.vue?vue&type=script&lang=ts&"
export * from "./CzIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CzIcon.vue?vue&type=style&index=0&id=02381da3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02381da3",
  null
  
)

export default component.exports